export const environment = {
  production: true,
  baseUrl: "https://staging.orangeflowers.eu/fiori-rs",
  titleSuffix: "Demo"
};
